var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "portlet-body form" }, [
      _c(
        "div",
        { staticClass: "widget-body" },
        [
          _c("wes-mtreeview", {
            staticStyle: { padding: "0 0 0 0 !important" },
            attrs: {
              id: "meutreeview",
              handle: "0",
              tabela: "ED_COMPETENCIAS",
              carga: "SPED",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "portlet-title" }, [
      _c("div", { staticClass: "caption collapsible" }, [
        _c(
          "span",
          { staticClass: "caption-subject font-green-sharp bold uppercase" },
          [_vm._v("Competências")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }